import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

type ConfirmDialogData = {
	title: string;
	message: string;
	confirmText?: string;
	cancelText?: string;
};

@Component({
	selector: 'app-confirm-dialog',
	imports: [MatDialogModule, MatButtonModule],
	templateUrl: './confirm-dialog.component.html',
	styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
	private dialogRef = inject(MatDialogRef<ConfirmDialogComponent, boolean>);

	data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);

	defaultCancelText = $localize`:@@Cancel:Cancel`;
	defaultConfirmText = $localize`:@@OK:OK`;

	onCancel(): void {
		this.dialogRef.close(false);
	}

	onConfirm(): void {
		this.dialogRef.close(true);
	}
}
